export const createSpeedSlice = (set) => ({
    playbackSpeed: 1,
    setPlaybackSpeed: (playbackSpeed) => set(() => ({ playbackSpeed })),
});
//# sourceMappingURL=speed.js.map